<template>
  <div class="sl-swap-assets gray-cl" :style="{height: boxHeight + 'px'}">
    <div class="block-header title main-bg">
      <!-- 资产 -->
      <span class="tab" v-if="isLogin && openContract" @click="switchBlock(1)" :class="{'main-cl': blockType === 1 }">
        {{lanText.text1}}
        <span class="selected blue-bg" v-if="blockType === 1"></span>
      </span>
      <!-- 合约信息 -->
      <span class="tab" @click="switchBlock(2)" :class="{'main-cl': blockType === 2 }">
        {{lanText.text2}}
        <span class="selected blue-bg" v-if="blockType === 2"></span>
      </span>
      <!-- 立即划转 -->
      <span class="float-right" v-if="blockType === 1 && openContract">
        <svg-icon class-name="blue-cl" iconClass="transfer-icon"></svg-icon>
        <a class="blue-cl" @click="openTransfer">
          {{lanText.text3}}
        </a>
      </span>
      <!-- 合约数据 -->
      <!-- <a class="float-right blue-cl" v-else @click="goFuturesData">
        {{lanText.text25}}
      </a> -->
    </div>

    <div class="main-bg" :style="{height: boxHeight - 27 + 'px'}">
      <vue-scroll>
        <template v-if="blockType === 1">
          <div v-if="balanceInfor.totalAmount && Number(balanceInfor.totalAmount) !== 0" class="assetsChart">
            <assetsChart :balanceInfor="balanceInfor" />
            <div class="total-rate">
              <p class="text-il">
                <span class="main-cl">
                  {{ balanceInfor.totalMarginRate }} %
                </span>
              </p>
              <div class="hint-father text-il">
                <a class="b-2-cl a-1-bd blue-cl-hover">
                  <!-- 账户保证金率 -->
                  {{lanText.text5}}
                </a>
                <!-- 账户保证金率=该币种总资产/该币种担保的仓位总价值。此值用来表示担保资产的大致水平。保证金率越低，仓位被强制平仓的风险越大。 -->
                <p class="hint main-second-bg main-cl" :class="hintClass" v-html="lanText.text6">
                </p>
              </div>
            </div>
          </div>
          <ul class="assets-list futures-info-list">
            <!-- 总资产 -->
            <li class="info-item main-second-bd">
              <div class="hint-father">
                <a class="b-2-cl blue-cl-hover">
                  {{ lanText.text7 }}
                </a>
                <p class="hint main-second-bg main-cl" :class="hintClass">
                  {{ marginCoin }}
                  <!-- 合约账户总权益。账户总权益=全仓总权益+逐仓总权益+冻结保证金。 -->
                  <span v-html="lanText.text8"></span>
                </p>
              </div>
              <span class="main-cl td">{{thousandsComma(balanceInfor.totalAmount)}}{{marginCoin}}</span>
            </li>
            <!-- 仓位保证金 -->
            <li class="info-item main-second-bd">
              <div class="hint-father">
                <a class="b-2-cl a-1-bd blue-cl-hover">
                  <!-- 全仓保证金 -->
                  {{lanText.text9}}
                </a>
                <!-- 所有用来担保全仓仓位的保证金。当全仓仓位被强制平仓时，会损失这些资产。
                请注意：转入合约账户的资产会自动作为全仓保证金。 -->
                <!-- {{}} -->
                <p class="hint main-second-bg main-cl" :class="hintClass" v-html="lanText.text10"></p>
              </div>
              <span class="main-cl td">{{thousandsComma(balanceInfor.totalMargin)}}{{marginCoin}}</span>
            </li>
            <!-- 未实现盈亏 -->
            <li class="info-item main-second-bd">
              <div class="hint-father">
                <a class="b-2-cl a-1-bd blue-cl-hover">
                  <!-- 逐仓保证金 -->
                  {{lanText.text11}}
                </a>
                <!-- 所有用来担保逐仓仓位的保证金。
                逐仓保证金和全仓分开，全仓仓位被强制平仓不会影响到这部分资产。 -->
                <p class="hint main-second-bg main-cl" :class="hintClass" v-html="lanText.text12"></p>
              </div>
              <span class="main-cl td">{{thousandsComma(balanceInfor.isolateMargin)}}{{marginCoin}}</span>
            </li>
            <!-- 冻结保证金 -->
            <li class="info-item main-second-bd">
              <div class="hint-father">
                <a class="b-2-cl blue-cl-hover">
                  <!-- 冻结保证金 -->
                  {{lanText.text13}}
                </a>
                <p class="hint main-second-bg main-cl" :class="hintClass">
                  <!-- 提交委托时冻结的委托保证金总和。 -->
                  {{lanText.text14}}
                </p>
              </div>
              <span class="main-cl td">{{thousandsComma(balanceInfor.lockAmount)}} {{marginCoin}}</span>
            </li>
          </ul>
        </template>
        <div class="futures-info-list main-bg" v-else>
          <div class="info-item main-second-bd">
            <span class="th">
              <!-- 合约代号 -->
              {{lanText.text15}}
            </span>
            <span class="td">{{ contractNames(contractInfo.symbol)}}</span>
          </div>
          <div class="info-item main-second-bd">
            <!-- 交割日期  -->
            <span class="th"> {{lanText.text16}}</span>
            <span class="td"> {{contractShowType}} </span>
          </div>
          <div class="info-item main-second-bd">
            <!-- 合约标的  -->
            <span class="th"> {{lanText.text17}}</span>
            <span class="td">{{contractInfo.symbol | setSymbolNumer}}
              <!-- 指数 -->
              {{lanText.text18}}
            </span>
          </div>
          <div class="info-item main-second-bd">
            <!-- 保证金币种  -->
            <span class="th"> {{lanText.text19}}</span>
            <span class="td">{{ marginCoin }}</span>
          </div>
          <div class="info-item main-second-bd">
            <!-- 合约面值  -->
            <span class="th"> {{lanText.text20}}</span>
            <span class="td">{{ thousandsComma(contractInfo.multiplier)}}{{contractInfo.multiplierCoin}}</span>
          </div>
          <div class="info-item main-second-bd">
            <!-- 最小价格变动单位  -->
            <span class="th">  {{lanText.text21}}</span>
            <span class="td">{{ pricefix | setfixNumer}} {{ priceUnit }}</span>
          </div>
          <div class="info-item main-second-bd">
            <!-- 最低维持保证金率  -->
            <span class="th">  {{lanText.text22}}</span>
            <span class="td">{{minMarginRate}}%</span>
          </div>
          <div class="info-item main-second-bd">
            <!-- 结算周期  -->
            <span class="th">  {{lanText.text23}}</span>
            <span class="td">{{contractInfo.settlementFrequency}}min</span>
          </div>
        </div>
      </vue-scroll>
    </div>

    <CommonTransfer ref="CommonTransfer" @success="transferSuccess" />
  </div>
</template>

<script>
import { fixD, thousandsComma } from '@/utils';
import CommonTransfer from '@/views/components/CommonTransfer.vue';
import assetsChart from './echarts/assetsChart.vue';

export default {
  components: {
    CommonTransfer,
    assetsChart,
  },
  mounted() {
    this.init();
  },
  data() {
    return {
      // 显示类型
      blockType: 2,
      boxHeight: 332,
      // 维持保证金列表
      ladderList: [],
      // 最低维持保证金绿
      minMarginRate: 0.00,
    };
  },
  computed: {
    lanText() {
      return {
        text1: this.$t('futures.assets.text1'), // '资产',
        text2: this.$t('futures.assets.text2'), // '合约信息',
        text3: this.$t('futures.assets.text3'), // '立即划转',
        text4: this.$t('futures.assets.text4'), // '更多',
        text5: this.$t('futures.assets.text5'), // '账户保证金率',
        text6: this.$t('futures.assets.text6'), // '账户保证金率=该币种总资产/该币种担保的仓位总价值。此值用来表示担保资产的大致水平。保证金率越低，仓位被强制平仓的风险越大。',
        text7: this.$t('futures.assets.text7'), // '总资产',
        text8: this.$t('futures.assets.text8'), // '合约账户总权益。账户总权益=全仓总权益+逐仓总权益+冻结保证金。',
        text9: this.$t('futures.assets.text9'), // '全仓保证金',
        text10: this.$t('futures.assets.text10'), // '所有用来担保全仓仓位的保证金。当全仓仓位被强制平仓时，会损失这些资产。请注意：转入合约账户的资产会自动作为全仓保证金。',
        text11: this.$t('futures.assets.text11'), // '逐仓保证金',
        text12: this.$t('futures.assets.text12'), // '所有用来担保逐仓仓位的保证金。逐仓保证金和全仓分开，全仓仓位被强制平仓不会影响到这部分资产。',
        text13: this.$t('futures.assets.text13'), // '冻结保证金',
        text14: this.$t('futures.assets.text14'), // '提交委托时冻结的委托保证金总和。',
        text15: this.$t('futures.assets.text15'), // '合约代号',
        text16: this.$t('futures.assets.text16'), // '到期日期',
        text17: this.$t('futures.assets.text17'), // '合约标的',
        text18: this.$t('futures.assets.text18'), // '指数',
        text19: this.$t('futures.assets.text19'), // '保证金币种',
        text20: this.$t('futures.assets.text20'), // '合约面值',
        text21: this.$t('futures.assets.text21'), // '最小价格变动单位',
        text22: this.$t('futures.assets.text22'), // '最低维持保证金率',
        text23: this.$t('futures.assets.text23'), // '结算周期',
        text24: this.$t('futures.assets.text24'), // '['永续', '周', '次周', '月', '季度'];',
        text25: this.$t('futures.assets.text25'), // '合约数据',
      };
    },
    deliveryKind() {
      return this.lanText.text24; //  ['永续', '周', '次周', '月', '季度'];
    },
    contractShowType() {
      if (this.contractInfo) {
        return this.deliveryKind[Number(this.contractInfo.deliveryKind)];
      }
      return this.deliveryKind[0];
    },
    // 是否登录
    isLogin() {
      if (this.$store.state.baseData.isLogin) {
        return this.$store.state.baseData.isLogin;
      }
      return false;
    },
    // 当前合约信息
    contractInfo() {
      if (this.$store.state.future.contractInfo) {
        return this.$store.state.future.contractInfo;
      }
      return {};
    },
    // 是否开通了合约交易
    openContract() {
      return this.$store.state.future.openContract;
    },
    // 当前合约价格单位
    priceUnit() {
      return this.$store.state.future.priceUnit;
    },
    // 当前合约保证金币种
    marginCoin() {
      if (this.contractInfo) {
        return this.contractInfo.marginCoin;
      }
      return '';
    },
    // 当前合约ID
    contractId() {
      return this.$store.state.future.contractId;
    },
    // 当前合约保证金币种精度
    marginCoinFix() {
      if (this.contractInfo && this.contractInfo.coinResultVo) {
        return this.contractInfo.coinResultVo.marginCoinPrecision;
      }
      return 4;
    },
    // 用户合约资产
    accountBalanceMap() {
      return this.$store.state.future.futureAccountBalance;
    },
    accountBalance() {
      if (this.accountBalanceMap && this.marginCoin) {
        return this.accountBalanceMap[this.marginCoin];
      }
      return {};
    },
    balanceInfor() {
      if (this.accountBalance) {
        return {
          // 全仓保证金率
          totalMarginRate: this.fixdRose(this.accountBalance.totalMarginRate),
          // 可用
          canUseAmount: fixD(this.accountBalance.canUseAmount, this.marginCoinFix),
          // 总资产
          totalAmount: fixD(this.accountBalance.totalAmount, this.marginCoinFix),
          // 全仓保证金
          totalMargin: fixD(this.accountBalance.totalMargin, this.marginCoinFix),
          // 逐仓保证金
          isolateMargin: fixD(this.accountBalance.isolateMargin, this.marginCoinFix),
          // 冻结保证金
          lockAmount: fixD(this.accountBalance.lockAmount, this.marginCoinFix),
          // 已实现盈亏
          realizedAmount: fixD(this.accountBalance.realizedAmount, this.marginCoinFix),
          // 未实现盈亏
          unRealizedAmount: fixD(this.accountBalance.unRealizedAmount, this.marginCoinFix),
        };

        // return {
        //   totalMarginRate: '+362649.3',
        //   canUseAmount: '5814.037904',
        //   totalAmount: '1134614.427979',
        //   totalMargin: '48129.487192',
        //   isolateMargin: '1080739.786449',
        //   lockAmount: '5745.154337',
        //   realizedAmount: '0.278400',
        //   unRealizedAmount: '-0.665100',
        // };
      }
      return {
        canUseAmount: '0', // 可用
        totalAmount: '0', // 总资产
        totalMargin: '0', // 全仓保证金
        isolateMargin: '0', // 逐仓保证金
        lockAmount: '0', // 冻结保证金
        realizedAmount: '0', // 已实现盈亏
        unRealizedAmount: '0', // 未实现盈亏
      };
    },
    // 当前合约价格精度
    pricefix() {
      return this.$store.state.future.pricefix;
    },
    hintClass() {
      if (this.balanceInfor.totalAmount && Number(this.balanceInfor.totalAmount) !== 0) {
        return 'position-top';
      }
      return '';
    },
    linkurl() {
      if (this.$store.state.baseData.publicInfo) {
        return this.$store.state.baseData.publicInfo.url;
      }
      return {};
    },

    // futuresDataUrl() {
    //   return '/futuresData';
    // },
  },
  watch: {
    isLogin(val) {
      if (val && this.openContract) {
        this.blockType = 1;
      } else {
        this.blockType = 2;
        this.getladderList();
      }
    },
    openContract(val) {
      if (val && this.isLogin) {
        this.blockType = 1;
      } else {
        this.blockType = 2;
        this.getladderList();
      }
    },
    contractId() {
      this.getladderList();
    },
  },
  filters: {
    setfixNumer(v) {
      if (v === 0) {
        return '1';
      }
      if (v === 1) {
        return '0.1';
      }
      return `${fixD(0, v - 1)}1`;
    },
    setSymbolNumer(name) {
      if (name) {
        return name.replace(/-/g, '');
      }
      return '';
    },
  },
  methods: {
    contractNames(data) {
      let name = data;
      if (data) {
        name = data.replace(/-/g, '');
      }
      // 混合合约 || 模拟合约
      let text = '';
      if (this.contractInfo.contractType !== 'E') {
        text = `-${this.contractInfo.marginCoin}`;
      }
      return `${name}${text}`;
    },

    init() {
      this.$bus.$on('syHeight', (val) => {
        this.boxHeight = val;
      });
      if (this.isLogin) {
        this.blockType = 1;
      } else {
        this.blockType = 2;
        this.getladderList();
      }
    },

    openTransfer() {
      this.$refs.CommonTransfer.show(this.marginCoin, true, 'future');
    },

    // 划转成功，重新获取账户信息
    transferSuccess() {
      setTimeout(() => {
        this.$store.dispatch('getPositionList');
      }, 500);
    },

    fixdRose(value) {
      if (value && value !== '--') {
        let slie = '';
        const val = parseFloat(value, 0);
        if (val > 0) { slie = '+'; }
        if (val < 0) { slie = '-'; }
        const num = Math.abs((value * 10000) / 100);
        return `${slie}${Number(num.toString().match(/^\d+(?:\.\d{0,2})?/))}`;
      }
      return value;
    },

    // 切换类型
    switchBlock(type) {
      if (this.blockType !== type) {
        this.blockType = type;
      }
      if (type === 2) {
        this.getladderList();
      }
    },

    // 获取阶梯设置列表
    getladderList() {
      if (!this.contractId) {
        return;
      }
      this.axios({
        url: this.$store.state.url.futures.getLadderInfo,
        method: 'post',
        hostType: 'co',
        params: {
          contractId: this.contractId,
        },
      }).then((rs) => {
        this.tableLoading = false;
        if (rs.code === '0' && rs.data) {
          if (rs.data.ladderList) {
            this.ladderList = rs.data.ladderList.ladderList || [];
            if (this.ladderList && this.ladderList.length) {
              const rate = this.ladderList[0].minMarginRate;
              this.minMarginRate = fixD(rate * 100, 2);
            }
          }
        }
      });
    },

    thousandsComma(num) {
      if (num) {
        return thousandsComma(num);
      }
      return num;
    },

    // // 跳转至合约数据页面
    // goFuturesData() {
    //   const type = myStorage.get('futuresMarketCurrent');
    //   this.$router.push(`${this.futuresDataUrl}?marginCoin=${this.marginCoin}&type=${type}&contractId=${this.contractId}`);
    // },
  },
};
</script>

<style lang="scss" scoped>
.sl-swap-assets {
  padding-bottom: 10px;
  position: relative;
  user-select: none;
  margin-top: 4px;

  .assets-risk {
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 0;
  }

  .title {
    height: 39px;
    line-height: 39px;
    padding: 0 15px;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    margin-bottom: 1px;

    .tab {
      display: inline-block;
      border-bottom-style: solid;
      border-bottom-width: 0px;
      height: 38px;
      line-height: 38px;
      cursor: pointer;
      user-select: none;
      margin-right: 28px;
      font-size: 14px;
      position: relative;

      .selected {
        width: 10px;
        height: 2px;
        position: absolute;
        left: 50%;
        bottom: -1px;
        transform: translateX(-50%);
        display: block;
      }
    }

    .assets-tit {
      display: flex;
      align-items: center;

      span {
        font-size: 14px;
      }

      i {
        font-size: 12px;
        margin-left: 3px;
      }
    }

    .float-right {
      float: right;

      svg {
        font-size: 12px;
      }
    }

    a {
      font-size: 12px;
      user-select: none;
    }
  }

  .assets-list {
    // padding: 5px 0;

    li {
      font-size: 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 6px 16px;
      position: relative;

      .clole-style {
        background: #fff;
        width: 10px;
        height: 10px;
        float: left;
        margin-top: 1px;
        margin-right: 5px;
        border-radius: 2px;

        &.clole-style_1 {
          background: #91C7AE;
        }

        &.clole-style_2 {
          background: #62A0A8;
        }

        &.clole-style_3 {
          background: #5183BB;
        }
      }

      .bg {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: none;
      }

      &:hover {
        .bg {
          display: block;
        }
      }

      span {
        position: relative;
      }
    }

    .total-amount {
      font-size: 14px;
      padding: 10px 16px;
      border-bottom-width: 1px;
      border-bottom-style: solid;
      margin-bottom: 5px;
    }

    .fee {
      padding: 10px;
      border-bottom-width: 1px;
      border-bottom-style: solid;
      margin-bottom: 5px;
    }
  }

  .risk {
    height: 62px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 15px;
    font-size: 12px;
    border-top-width: 1px;
    border-top-style: solid;

    h3 {
      font-size: 14px;
    }

    .limit {
      div {
        margin: 8px 0px;
      }
    }
  }

  .assetsChart {
    height: 220px;
    position: relative;
    padding-top: 10px;

    .total-rate {
      position: absolute;
      top: 90px;
      text-align: center;
      width: 100%;
      font-size: 12px;
      line-height: 18px;

      .text-il {
        width: 100px;
        margin: 0 auto;
      }

      .hint {
        top: auto;
        bottom: 18px;
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 17px;
        border-radius: 4px;
        padding: 5px 8px;
        width: 200px;
        left: -56px;
      }
    }
  }

  .futures-info-list {
    // padding: 10px 0;

    .info-item {
      height: 36px;
      width: 100%;
      font-size: 12px;
      line-height: 36px;
      padding: 0 16px;
      box-sizing: border-box;
      border-bottom-width: 1px;
      border-bottom-style: solid;

      >span {
        display: inline-block;
        width: 50%;

        &.td {
          text-align: right;
        }
      }
    }
  }

  .hint-father {
    position: relative;

    >a {
      cursor: pointer;
      border-bottom-style: dashed;
      border-bottom-width: 1px;
      position: relative;

      &:hover {
        +p {
          display: block;
        }
      }
    }

    .hint {
      display: none;
      width: 200px;
      position: absolute;
      left: 0px;
      top: 32px;
      z-index: 10;
      padding: 5px 8px;
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 17px;
      border-radius: 4px;
      height: max-content;
    }
  }

  .position-top {
    top: auto;
    bottom: 18px;
  }
}
</style>
